import { render, staticRenderFns } from "./NewsTwo.vue?vue&type=template&id=579720e4&scoped=true"
import script from "./NewsTwo.vue?vue&type=script&lang=js"
export * from "./NewsTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579720e4",
  null
  
)

export default component.exports